import type { LightboxControlReturn } from '../Lightbox';
import { CloseButton, Lightbox } from '../Lightbox';
import type { FC, PropsWithChildren } from 'react';

import classNames from 'classnames';
import {
  getModalDesign,
  getNonWaveDesign,
  // getWaveSectionDesign,
  // getBelowWaveSectionDesign,
} from '../../designs/getModalDesign';

import styles from './Modal.css';

const UNSET_WIDTH = '';
const MIN_HEIGHT = 0;

export interface ModalProps extends LightboxControlReturn {
  /** Toggle if clicking background closes the modal */
  disableInteractions?: boolean;
  className?: string;
}

export const Modal: FC<PropsWithChildren<ModalProps>> = ({
  children,
  rootProps,
  disableInteractions = false,
  className,
  ...props
}) => {
  const modalDesign = getModalDesign();
  const nonWaveDesign = getNonWaveDesign();

  return (
    <Lightbox
      width={UNSET_WIDTH}
      height={MIN_HEIGHT}
      className={classNames(modalDesign, className, nonWaveDesign)}
      disableInteractions={disableInteractions}
      {...rootProps}
      {...props}
    >
      {!disableInteractions && (
        <CloseButton onClick={props.close} className={styles.closeButton} />
      )}
      {children}
    </Lightbox>
  );
};
